import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0ca479f0&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&lang=css&"
import style1 from "./home.vue?vue&type=style&index=1&id=0ca479f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca479f0",
  null
  
)

export default component.exports